import RenderRank from '../RenderRank';
import { Stack } from '@mui/system';
import { Avatar } from '@mui/material';
import { ReactComponent as IconUp } from '@/views/assets/icons/up.svg';
import { ReactComponent as IconDown } from '@/views/assets/icons/down.svg';
import { useState } from 'react';
import { getFirstCharacterName } from '@/utilities';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import { useTranslation } from 'react-i18next';

interface UserIntroduceProps {
  name: string;
  avatarUrl?: string;
  rank: string;
  registerDate: string;
  investthesis?: string;
  shortinvestthesis?: string;
  linkaccount?: string;
  custodycd?: string;
}

const UserIntroduce = ({ name, avatarUrl, rank, investthesis, shortinvestthesis, registerDate, custodycd, linkaccount }: UserIntroduceProps) => {
  const { t } = useTranslation()
  const [expanded, setExpanded] = useState<boolean>(false)

  return (
    <Stack
      direction={"row"}
      spacing={1}
      sx={{
        maxWidth: "350px",
        flex: 3,
        marginRight: "50px",
      }}
    >
      {avatarUrl ? <img src={avatarUrl} alt={`${name}'s avatar`} style={{ borderRadius: '6px', width: '48px', height: '48px' }} />
      : <Avatar sx={{ borderRadius: '6px', width: '48px', height: '48px' }} aria-label="recipe" variant="square">
          {getFirstCharacterName(name)}
        </Avatar>}
      <Stack direction={"column"} spacing={1}>
        <Stack direction={"column"} spacing={1}>
          <Stack>
            <Stack direction={"row"} spacing={2} alignItems={"center"}>
            <TypographyElement marginBottom='20px' FontSizeElement='18px' FontWeightElement={700} sx={{ lineHeight: '21px'}}>{name}</TypographyElement>
              <RenderRank rank={rank} sx={{ marginLeft: '10px !important', padding: '0 5px !important'}} />
            </Stack>
            <TypographyElement ColorElement='secondary' FontSizeElement='14px' FontWeightElement={400} sx={{ lineHeight: '28px'}}>{t('copytrade.userinfo.registerDate')}: {registerDate}</TypographyElement>
            {custodycd &&
              <TypographyElement ColorElement='secondary' FontSizeElement='14px' FontWeightElement={400} sx={{ lineHeight: '28px'}}>{t('copytrade.userinfo.custodycd')}: {custodycd}</TypographyElement>
            }
            {linkaccount &&
              <TypographyElement ColorElement='secondary' FontSizeElement='14px' FontWeightElement={400} sx={{ lineHeight: '28px'}}>{t('copytrade.userinfo.linkaccount')}: {linkaccount}</TypographyElement>
            }
          </Stack>
          <Stack>
            <TypographyElement ColorElement='secondary' FontSizeElement='14px' FontWeightElement={400} sx={{ lineHeight: '21px'}}>{shortinvestthesis}</TypographyElement>
          </Stack>
        </Stack>
        <Stack display={!custodycd ? 'block' : 'none'}>
          {expanded ? (
            <Stack gap='10px'>
              <TypographyElement ColorElement='secondary' FontSizeElement='14px' FontWeightElement={400} sx={{ lineHeight: '21px' }}>{investthesis}</TypographyElement>
              <TypographyElement ColorElement='brand' FontSizeElement='14px' onClick={() => setExpanded(false)} sx={{ cursor: 'pointer', marginBottom: '20px' }}>
              {t('copytrade.userinfo.shorten')} <IconUp />
              </TypographyElement>
            </Stack>
          ) : (
              <TypographyElement onClick={() => setExpanded(true)} ColorElement='brand' FontSizeElement='14px' sx={{ cursor: 'pointer', marginBottom: '20px' }}>
                {t('copytrade.userinfo.investthesis')} <IconDown />
              </TypographyElement>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default UserIntroduce;